<div class="component">
  <div class="typo-14-bold title">
    {{contactGufItem.guichet}}
  </div>

  <div>
    <b class="typo-14-bold item">Adresse</b> : <span class="orange">{{contactGufItem.adresse}}</span>
  </div>

  <div>
    <b class="typo-14-bold item">Téléphone n°1</b> : <span class="orange">{{contactGufItem.telephone1}}</span>
  </div>

  <div>
    <b class="typo-14-bold item">Téléphone n°2</b> : <span class="orange">{{contactGufItem.telephone2}}</span>
  </div>

  <div>
    <b class="typo-14-bold item">Localisation</b> : <span class="orange">{{contactGufItem.localisation}}</span>
  </div>

  <div>
    <b class="typo-14-bold item">Email</b> : <span class="orange">{{contactGufItem.email}}</span>
  </div>
  <div *ngIf="showLocaliser">
    <b  class="typo-14-bold item">Distance</b> : <span class="orange">{{contactGufItem.distanceFormated}}</span>
  </div>
  <div class="item btn-localiser">
    <ion-button *ngIf="showLocaliser" (click)="clickEvent()"
                class="typo-14-white ion-text-uppercase">
      Localiser
    </ion-button>
  </div>
</div>

